const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\u56FE\\u5C42_1",
    "data-name": "\\u56FE\\u5C42 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M129,5.7C61.3,5.8,6.5,60.7,6.4,128.4c0,67.6,55,122.6,122.6,122.6s122.6-55,122.6-122.6c0-67.7-54.9-122.6-122.6-122.6ZM129,233.5c-57.9,0-105.1-47.1-105.1-105.1S71.1,23.3,129,23.3s105.1,47.1,105.1,105.1-47.1,105.1-105.1,105.1h0Z",
    style: {
      fill: "#000",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.5,119.6h-41.7v-41.7c0-4.8-3.9-8.8-8.8-8.8s-8.8,3.9-8.8,8.8v41.7h-41.7c-4.8,0-8.8,3.9-8.8,8.8s3.9,8.8,8.8,8.8h41.7v41.7c0,4.8,3.9,8.8,8.8,8.8,4.8,0,8.8-3.9,8.8-8.8v-41.7h41.7c4.8,0,8.8-3.9,8.8-8.8s-3.9-8.8-8.8-8.8Z",
    style: {
      fill: "#f20",
      strokeWidth: 0
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.06316cc3e738f7d97e88633df68e74ac.svg";
export { ForwardRef as ReactComponent };